<template lang="html">
  <Offscreen
    :visible="$store.state.ui.offscreenVisible"
    class="offscreen-navigation"
    @close="$store.commit('ui/closeOffscreen')"
  >
    <LogoStiftung
      v-if="logoImage === 'stiftung'"
      slot="logo"
      class="offscreen-navigation__logo"
    />
    <LogoHolding
      v-if="logoImage === 'holding'"
      slot="logo"
      :site="$route.params.country === 'ch' ? 'holding' : 'capital'"
      class="offscreen-navigation__logo"
    />
    <div class="offscreen-navigation__search">
      <SearchField @submit="handleSearch" />
    </div>
    <Navigation>
      <NavigationItem
        v-for="item in items"
        :key="item.id"
      >
        <AppLink
          :is-link="!!item.targetPage.url"
          :to="item.targetPage.url"
        >
          {{ item.readableName }}
        </AppLink>
        <LinkList
          v-if="item.children"
          slot="toggable"
          :items="item.children"
          class="offscreen-navigation__link-list"
        />
      </NavigationItem>
      <NavigationItem
        v-for="action in actions"
        :key="action.id"
      >
        <nuxt-link
          v-if="action.resource.targetPage"
          :to="action.resource.targetPage.url"
        >
          <Button
            :padded="false"
            :size="1"
            type="bare"
          >
            <component
              :is="action.icon"
              slot="before"
            />
            {{ action.resource.targetPage.readableName }}
          </Button>
        </nuxt-link>
        <a
          v-else-if="action.resource.columns.targetUrl"
          :href="action.resource.columns.targetUrl"
          target="_blank"
        >
          <Button
            :padded="false"
            :size="1"
            type="bare"
          >
            <component
              :is="action.icon"
              slot="before"
            />
            {{ action.resource.readableName }}
          </Button>
        </a>
      </NavigationItem>
      <NavigationItem @click="countryLanguageSelectorVisible = !countryLanguageSelectorVisible">
        <CurrentLanguage :country="country" :locale="locale" class="offscreen-navigation__current-language" />
        <div slot="toggable">
          <CountryLanguageSelector
            :countries="countries"
          />
        </div>
      </NavigationItem>
    </Navigation>
  </Offscreen>
</template>

<script>
import { Resource } from 'beisheim/models'
import CurrentLanguage from 'beisheim/components/elements/current-language'
import Offscreen from 'beisheim/components/elements/offscreen'
import SearchField from 'beisheim/components/elements/search-field'
import LogoStiftung from 'beisheim/components/elements/logo-stiftung'
import LogoHolding from 'beisheim/components/elements/logo-holding'
import Navigation from 'beisheim/components/elements/navigation'
import NavigationItem from 'beisheim/components/elements/navigation-item'
import Button from 'beisheim/components/elements/button'
import LinkList from 'beisheim/components/elements/link-list'
import CountryLanguageSelector from 'beisheim/components/elements/country-language-selector'
import AppLink from 'beisheim/components/elements/app-link'

export default {
  components: {
    CurrentLanguage,
    LinkList,
    CountryLanguageSelector,
    Button,
    Navigation,
    NavigationItem,
    Offscreen,
    SearchField,
    LogoStiftung,
    LogoHolding,
    AppLink
  },
  props: {
    logoImage: {
      type: String,
      default: () => ''
    },
    locale: {
      type: Object,
      default: () => ({})
    },
    locales: {
      type: Array,
      default: () => []
    },
    country: {
      type: Object,
      default: () => ({})
    },
    countries: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    actions: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      countryLanguageSelectorVisible: false,
      search: ''
    }
  },
  watch: {
    '$store.state.ui.offscreenVisible': function changedOffscreenState (newVal) {
      if (newVal) {
        document.querySelector('body').classList.add('body--offscreen-open')
      } else {
        document.querySelector('body').classList.remove('body--offscreen-open')
      }
    },
  },
  mounted() {
    if (!this.$store.state.ui.offscreenVisible) {
      document.querySelector('body').classList.remove('body--offscreen-open')
    }

  },
  methods: {
    handleSearch (search) {
      const searchResource = Resource.query().where(
        r =>
          r.country === this.$country &&
          r.language === this.$language &&
          r.name === 'search' &&
          !!r.url
      ).first()
      this.$router.push({
        path: searchResource.url,
        query: {
          text: search
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import 'beisheim/scss/scale';
@import 'beisheim/scss/breakpoints';
@import 'beisheim/scss/font-sizes';

.body--offscreen-open {
  @include to(3) {
    overflow: hidden;
    position:relative;
  }
}

.offscreen-navigation {
  @include from(4) {
    display: none;
  }

  &__logo {
    width: 50%;
  }

  .country-language-selector__title {
    font-size: 0.8rem;
  }

  .country-language-selector__link {
    font-size: font-size(0);
  }
}

.offscreen-navigation__current-language {
  font-size: font-size(1);
}

.offscreen-navigation__search {
  margin-bottom: scale(5);
}

.offscreen-navigation__link-list {
  margin-left: scale(5);
}
</style>
